<div class="premium-calculation">
  <small class="text-muted">
    Fahrrad oder E-Bike
  </small>

  <form
    (ngSubmit)="submit()"
    [formGroup]="form">

    <div class="row">
      <div class="col-12 mt-3">
        <div class="form-check form-check-inline">
          <input
            [formControl]="form.controls.isEbike"
            [value]="false"
            class="form-check-input"
            id="inlineRadio1"
            name="inlineRadioOptions"
            type="radio">

          <label
            class="form-check-label"
            for="inlineRadio1">Fahrrad</label>
        </div>

        <div class="form-check form-check-inline">
          <input
            [formControl]="form.controls.isEbike"
            [value]="true"
            class="form-check-input"
            id="inlineRadio2"
            name="inlineRadioOptions"
            type="radio">

          <label
            class="form-check-label"
            for="inlineRadio2">E-Bike</label>
        </div>
      </div>

      <div class="col-md-6">
        <div class="mt-3">
          <label
            class="form-label"
            for="price">Kaufpreis (inkl. Zubehör)</label>

          <input
            [formControl]="form.controls.price"
            class="form-control form-control-sm"
            id="price"
            type="number">
        </div>
      </div>

      <div class="col-md-6">
        <div class="mb-3 mt-3">
          <label
            class="form-label"
            for="premium">Prämie jährlich</label>

          <input
            [formControl]="form.controls.premium"
            class="form-control form-control-sm"
            id="premium"
            type="number">
        </div>
      </div>
    </div>

    <div>
      @if (showError) {
        <div>
          Der Kaufpreis muss zwischen 499.99 € und 15.000 € liegen!
        </div>
      }

      <button
        class="btn btn-sm btn-primary ms-auto d-flex"
        type="submit">Antrag erstellen
      </button>
    </div>
  </form>
</div>
